var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_836_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.5803 0C55.014 1.44181e-07 41.7524 4.02299 30.4727 11.5602C19.1929 19.0974 10.4015 29.8103 5.21041 42.3441C0.0192904 54.8778 -1.33844 68.6695 1.30893 81.9749C3.95631 95.2804 10.4899 107.502 20.0833 117.094C29.6768 126.686 41.8993 133.218 55.2052 135.863C68.511 138.509 82.3024 137.149 94.8355 131.956C107.368 126.763 118.08 117.97 125.616 106.689C133.151 95.4084 137.172 82.1462 137.17 68.58C137.168 50.3905 129.94 32.947 117.077 20.086C104.214 7.22505 86.7697 -1.93316e-07 68.5803 0V0ZM68.5803 111C60.1989 110.994 52.0073 108.504 45.0409 103.843C38.0745 99.1833 32.646 92.5626 29.4413 84.8181C26.2366 77.0736 25.3997 68.5528 27.0363 60.3328C28.6728 52.1127 32.7095 44.5623 38.636 38.6358C44.5626 32.7092 52.113 28.6726 60.333 27.036C68.5531 25.3994 77.0738 26.2363 84.8184 29.441C92.5629 32.6457 99.1836 38.0743 103.844 45.0407C108.504 52.0071 110.994 60.1986 111 68.58C111.006 74.1522 109.912 79.6706 107.782 84.8197C105.652 89.9687 102.528 94.6471 98.5875 98.5872C94.6474 102.527 89.9689 105.652 84.8199 107.782C79.6709 109.912 74.1524 111.005 68.5803 111Z",
    fill: "#F9BE5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_836_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137.17,
    height: 137.17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeCircle);
export default __webpack_public_path__ + "static/media/orange_circle.ed2b46044c2cd1054b9398147c407d91.svg";
export { ForwardRef as ReactComponent };